import React from 'react'
import PropTypes from 'prop-types'

const DirectorioTable = ({
    conductores,
    onRowClick,
    pageIndex,
    pageCount,
    onPageChange,
    pageSize,
    onPageSizeChange,
    total,
    loading
}) => {
    const columns = [
        { Header: 'Usuario', accessor: 'empresa.usuario_movil' },
        { Header: 'Empresa', accessor: 'empresa.sigla' },
        { Header: 'Teléfono', accessor: 'telefono' },
        { Header: 'Email', accessor: 'email' }
    ]

    // Renderizar cabecera
    const renderHeader = () => (
        <tr>
            {columns.map(col => (
                <th key={col.accessor}>{col.Header}</th>
            ))}
        </tr>
    )

    // Renderizar filas
    const renderRows = () =>
        conductores.map((row, idx) => (
            <tr key={row.id || idx} style={{ cursor: 'pointer' }} onClick={() => onRowClick(row)}>
                <td>{row.empresa?.usuario_movil || ''}</td>
                <td>{row.empresa?.sigla || ''}</td>
                <td>{row.telefono || ''}</td>
                <td>{row.email || ''}</td>
            </tr>
        ))

    // Renderizar paginación
    const renderPagination = () => (
        <div className="d-flex justify-content-between align-items-center mt-2">
            <div className="d-flex align-items-center gap-2">
                <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => onPageChange(0)}
                    disabled={pageIndex === 0}>
                    {'<<'}
                </button>
                <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => onPageChange(pageIndex - 1)}
                    disabled={pageIndex === 0}>
                    {'<'}
                </button>
                <span style={{ minWidth: 90, textAlign: 'center' }}>
                    Página <strong>{pageIndex + 1}</strong> de <strong>{pageCount}</strong>
                </span>
                <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => onPageChange(pageIndex + 1)}
                    disabled={pageIndex + 1 >= pageCount}>
                    {'>'}
                </button>
                <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => onPageChange(pageCount - 1)}
                    disabled={pageIndex + 1 >= pageCount}>
                    {'>>'}
                </button>
            </div>
            <div className="d-flex align-items-center gap-2">
                <span className="me-2">
                    Total registros: <strong>{total}</strong>
                </span>
                <select
                    value={pageSize}
                    onChange={e => onPageSizeChange(Number(e.target.value))}
                    className="form-select form-select-sm"
                    style={{ width: 'auto', display: 'inline-block' }}>
                    {[10, 20, 30].map(size => (
                        <option key={size} value={size}>
                            Mostrar {size}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )

    return (
        <div style={{ width: '100%', overflowX: 'auto' }}>
            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '120px' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                </div>
            ) : (
                <>
                    <table className="table table-hover" style={{ minWidth: '600px' }}>
                        <thead>{renderHeader()}</thead>
                        <tbody>
                            {conductores.length > 0 ? (
                                renderRows()
                            ) : (
                                <tr>
                                    <td colSpan={columns.length} className="text-center">
                                        No se encontraron conductores
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {renderPagination()}
                </>
            )}
        </div>
    )
}

DirectorioTable.propTypes = {
    conductores: PropTypes.array.isRequired,
    onRowClick: PropTypes.func.isRequired,
    pageIndex: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    pageSize: PropTypes.number.isRequired,
    onPageSizeChange: PropTypes.func.isRequired,
    total: PropTypes.number.isRequired,
    loading: PropTypes.bool
}

export default DirectorioTable
